import { useI18n } from '../../../i18n';

export function PlaceholderPanel({ title }: { title: string }) {
  const { t } = useI18n();
  return (
    <div style={{ padding: 48, textAlign: 'center', color: 'rgba(0,0,0,0.38)' }}>
      <div style={{ fontSize: 16, fontWeight: 500 }}>{title}</div>
      <div style={{ fontSize: 14, marginTop: 8 }}>{t.common.enDesarrollo}</div>
    </div>
  );
}
